export default __webpack_public_path__ + "static/Large_Tek_Wall-fff5df5089e23f290c26e4d42fd33491.png";